import React from 'react';
import LiteralsService from 'src/services/literals/LiteralsService';
import FormatService from 'src/services/format.service';
import styles from './spendingOverview.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import Selectors from 'src/utils/selectors';
import BudgetAmount from 'src/components/atomic/molecules/budgetAmount/BudgetAmount';
import Circle from 'src/components/atomic/atoms/circle/Circle';

interface OverviewProps {
    onClick: () => void;
    fullTagName: string;
    categoryName: string;
    'aria-label': string;
    percentSpent: number;
    isMinWidthSmall?: boolean;
    budgetAmount?: number;
}

export default function SpendingOverview({
    onClick,
    fullTagName,
    categoryName,
    'aria-label': ariaLabel,
    budgetAmount,
    percentSpent,
    isMinWidthSmall
}: OverviewProps): JSX.Element {
    const formattedPercentSpent: string = LiteralsService.getLiteral('SpendingOverview.percentOfTotal', [
        percentSpent * 100 >= 1 ? FormatService.formatPercent(percentSpent * 100, 0) : '<1%'
    ]);
    const hasBudget = !!budgetAmount;

    return (
        <div className={styles.overviewInfo}>
            <Typography variant={TypographyVariants.LINK_2} className={styles.categoryName}>
                <Anchor
                    onClick={onClick}
                    tag={fullTagName}
                    aria-label={ariaLabel}
                    data-cy={Selectors.SpendSmart.SPENDING_OVERVIEW_CATEGORY}
                >
                    {categoryName}
                </Anchor>
            </Typography>
            <div className={styles.budgetOverview}>
                <Typography
                    variant={TypographyVariants.LEGAL_PRIMARY}
                    className={styles.spendingOverviewPercentSpent}
                    data-cy={Selectors.SpendSmart.SPENDING_OVERVIEW_PERCENT_SPENT}
                >
                    {formattedPercentSpent}
                </Typography>
                {hasBudget && isMinWidthSmall && (
                    <>
                        <Circle style={{ height: 4, width: 4, minWidth: 'unset' }} className={styles.ellipsis} />
                        <BudgetAmount amount={budgetAmount} />
                    </>
                )}
            </div>
        </div>
    );
}
